import { useQuery } from "@tanstack/react-query";
import fetchRewardsExperience from "./fetchRewardsExperience";
var useRewardsExperienceQuery = function (config) {
    return useQuery({
        queryKey: ["rewards-experience"],
        queryFn: function () { return fetchRewardsExperience(config); },
        staleTime: Infinity,
        retry: false,
        refetchOnWindowFocus: false,
    });
};
export default useRewardsExperienceQuery;
